import React from 'react';
import classnames from 'classnames';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import Flex from '@wix/da-ds/pkg/Flex';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './WidgetHeader.scss';
const WidgetHeader = ({ header, subHeader, count, className, extras })=>{
    const hasContent = !!(header || subHeader);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], subHeader && s['with-subheader'], className)
    }, hasContent && /*#__PURE__*/ React.createElement(Flex, {
        direction: "column",
        gap: 4,
        fullWidth: true
    }, header && /*#__PURE__*/ React.createElement(Heading, {
        className: s['header']
    }, header, !!count && ' ', !!count && /*#__PURE__*/ React.createElement("span", {
        className: s['count']
    }, shortenNumber(count))), subHeader && /*#__PURE__*/ React.createElement("div", {
        className: s['subheader']
    }, subHeader)), extras);
};
WidgetHeader.displayName = 'WidgetHeader';
export default WidgetHeader;

//# sourceMappingURL=WidgetHeader.js.map